/**
 * Component: sa-product-specs-geometry
 * Description: Tabbed Specs & Geometry component with scoped queries and lifecycle cleanup.
 */
if (!customElements.get('sa-product-specs-geometry')) {
  class SaProductSpecsGeometry extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.sa-product-specs-geometry__tab'));
      this.panels = Array.from(this.querySelectorAll('.sa-product-specs-geometry__panel'));

      this.defaultTab = this.getAttribute('data-default-tab') || 'geometry';
      const schemaDefault = this.getAttribute('data-schema-default-tab');
      if (schemaDefault) this.defaultTab = schemaDefault;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
        tab.addEventListener('keydown', this.handleKeydown.bind(this));
      });

      const available = this.tabs.map((t) => t.getAttribute('data-tab'));
      let target = this.defaultTab;
      if (!available.includes(target)) {
        target = available[0] || (this.panels[0]?.getAttribute('data-panel') || 'geometry');
      }
      this.activateTab(target);
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
        tab.removeEventListener('keydown', this.handleKeydown);
      });
    }

    handleTabClick(e) {
      const target = e.currentTarget;
      const tab = target.getAttribute('data-tab');
      if (!tab) return;
      this.activateTab(tab);
    }

    activateTab(tabName) {
      this.tabs.forEach((t) => {
        const isActive = t.getAttribute('data-tab') === tabName;
        t.classList.toggle('sa-product-specs-geometry__tab--active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((p) => {
        const match = p.getAttribute('data-panel') === tabName;
        if (match) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    handleKeydown(e) {
      const key = e.key;
      if (key === 'Enter' || key === ' ') {
        e.preventDefault();
        const tab = e.currentTarget.getAttribute('data-tab');
        if (tab) this.activateTab(tab);
      }
    }
  }

  customElements.define('sa-product-specs-geometry', SaProductSpecsGeometry);
}
